import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import get from 'lodash/get';
import { useTranslation } from '../../src/i18n';
import { getRouteWithSlug } from '../../utils/common';
import route from '../../constants/routes';
import NextLink from '../NextLink';
import { TP, dateFormats, EMPTY_INFO_MARK } from '../../constants/consts';
import TitledBlock from '../TitledBlock';
import ListText from '../ListText';
import { createDate } from '../../utils/date';

const useStyles = makeStyles(theme => ({
  productionBlock: {
    display: 'flex',
    width: '100%',
    maxWidth: 1200,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  contentBox: {
    marginRight: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginRight: 0,
    },
  },
}));

const ReviewProductionBlock = ({ className, review, isEditMode }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  // as we have separate fields for production and other info we should check both options
  // TODO change when api supports getting role, performnce date
  const work = get(review, 'production.work') || get(review, 'work');
  const company = get(review, 'production.company') ? get(review, 'production.company') : { name: review?.house };
  const production = get(review, 'production', {});
  const composer = review?.production?.work?.workComposer;
  const performanceAt = review?.performanceAt;
  const role = review?.workRole?.name;

  return (
    <div className={cn(classes.productionBlock, className)}>
      <div className={classes.contentBox}>
        <TitledBlock title={t(`${TP}.m_ARTICLES_PERF_DATE`)}>
          {performanceAt ? createDate(performanceAt).format(dateFormats.shortMonthEvent) : EMPTY_INFO_MARK}
        </TitledBlock>
        <TitledBlock title={t(`${TP}.m_MUSICALWORK`)}>
          {isEditMode && (work?.name || EMPTY_INFO_MARK)}
          {!isEditMode &&
            (work ? (
              <NextLink target="blank" href={`${route.WORKS}/[id]`} as={getRouteWithSlug(route.WORKS, work)}>
                {work?.name || EMPTY_INFO_MARK}
              </NextLink>
            ) : (
              EMPTY_INFO_MARK
            ))}
        </TitledBlock>
        <TitledBlock title={t(`${TP}.m_ROLE`)}>{role || EMPTY_INFO_MARK}</TitledBlock>
        <TitledBlock title={t(`${TP}.m_COMPOSER`)}>{composer?.name || EMPTY_INFO_MARK}</TitledBlock>
        <TitledBlock title={t(`${TP}.m_COMPANY`)}>
          <ListText list={production?.companies || company} />
        </TitledBlock>
      </div>
      {production && (
        <NextLink target="blank" href={getRouteWithSlug(route.PRODUCTIONS, production)}>
          {t(`${TP}.FN_PRODUCTION_CARD_DETAILS`)}
        </NextLink>
      )}
    </div>
  );
};

ReviewProductionBlock.propTypes = {
  className: PropTypes.string,
  review: PropTypes.object.isRequired,
  isEditMode: PropTypes.bool,
};

ReviewProductionBlock.defaultProps = {
  className: '',
  isEditMode: false,
};

export default ReviewProductionBlock;
